import React from 'react';
import { useTranslation } from 'react-i18next';
import { LevelContainer, LevelTitle, LevelBlocks, Block } from './styles';

const Level = ({ level = '' }) => {
  const { t } = useTranslation();
  const colors = ['redNoTRecommended', 'midOrange', 'darkestYellow', 'appleGreen', 'midDarkGreen'];
  const levelCompare = level && level.toString();
  return (
    <LevelContainer data-panel='panel-level-container'>
      <LevelTitle data-panel='panel-level-title' color={colors[level - 1]}>
        {t('panel.avisos.reputationLevelModal.level')} {level || '-'}
      </LevelTitle>
      <LevelBlocks data-panel='panel-level-blocks'>
        {colors.map((color, index) => (
          <Block key={`n°-${index + 1}`} color={color} active={(index + 1).toString() === levelCompare} />
        ))}
      </LevelBlocks>
    </LevelContainer>
  );
};

export default Level;
